import React from 'react';

const isClient = typeof window === 'object';

const getSize = () => ({
  width: isClient ? window.innerWidth : undefined,
  height: isClient ? window.innerHeight : undefined,
});

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = React.useState(getSize);

  const handleResize = () => {
    setWindowSize(getSize());
  };

  React.useEffect(() => {
    if (!isClient) return false;

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};
